import { render, staticRenderFns } from "./reloadBox.vue?vue&type=template&id=74c484ff&scoped=true&"
import script from "./reloadBox.vue?vue&type=script&lang=js&"
export * from "./reloadBox.vue?vue&type=script&lang=js&"
import style0 from "./reloadBox.vue?vue&type=style&index=0&id=74c484ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c484ff",
  null
  
)

export default component.exports